import { render, staticRenderFns } from "./CompetencyDetail.vue?vue&type=template&id=2b69f496&scoped=true"
import script from "./CompetencyDetail.vue?vue&type=script&lang=js"
export * from "./CompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetencyDetail.vue?vue&type=style&index=0&id=2b69f496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69f496",
  null
  
)

export default component.exports